import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";

export const ProfileCta = () => (
  <section className="bg-white" data-testid="profile-cta-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-28">
      <Reveal>
        <div className="relative border border-gold/40 bg-paper px-8 py-14 sm:px-14 lg:px-20 lg:py-20 overflow-hidden">
          <div className="absolute top-0 left-0 h-1 w-full bg-forest" aria-hidden="true" />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <Eyebrow>The InSight Health Profile</Eyebrow>
              <h2 className="mt-5 font-serif font-medium text-forest text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
                Before we meet, tell us what matters to you.
              </h2>
              <p className="mt-6 text-inkmuted leading-relaxed max-w-xl">
                This short questionnaire helps us understand your primary concerns, goals and current lifestyle
                before your consultation.
              </p>
              <p className="mt-4 font-mono text-[11px] tracking-[0.22em] uppercase text-gold">
                Approximately 5 minutes
              </p>
            </div>
            <div className="lg:col-span-4 lg:text-right">
              <Link
                to="/health-profile"
                data-testid="profile-cta-button"
                className="inline-flex items-center gap-3 rounded-full bg-forest text-ivory px-9 py-4 text-sm font-semibold tracking-wide border border-gold/40 hover:bg-forestdeep transition-colors duration-300"
              >
                Begin Your Health Profile
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
